
import axios from 'axios'
const getDefaultState = () => {
    return {
        styles: []
    }
}
const state = getDefaultState()

const getters = {
    getStyles(state){
        return state.styles;
    },
    getEmisAppSetting(state){
        let appSetting = '';
        
        if (state.styles.length > 0) {
          state.styles[0].AppSettings.forEach(appSettingFromApi => {
              if(appSettingFromApi.AppName == "EMIS"){
                  appSetting = appSettingFromApi;
              }
          });
        }

        return appSetting;
    },
    getCompanyEmail(state){
      if (state.styles.length > 0) {
        return state.styles[0].Email;
      } else {
        return ''
      }
    },
    getCompanyTel(state){
      if (state.styles.length > 0) {
        return state.styles[0].Tel;
      } else {
        return ''
      }
    },
    getCompanyLogo: (state, getters) => (colorType) => {
        let companyLogo = '';

        if (getters.getEmisAppSetting !== '') {
          getters.getEmisAppSetting.Logo.forEach(logo => {
              if(logo.Type == colorType){
                  companyLogo = logo.Url;
              }
          });
        }

        return companyLogo;
    }
}
const actions = {
    fetchStyles({state, commit}){
        return axios({
            method: "get",
            url: process.env.VUE_APP_ASSET_URL + '/companies.json'
        }).then(function(response){
            commit("setStyles", response.data)
        }).catch(function(err){
            console.error(err)
        });
    }
}

// mutations
const mutations = {
    setStyles(state, stylesFromApi){
        state.styles=stylesFromApi;
    }
}

export default {
    state,
    getters,
    actions,
    mutations
}